import { Leaf, Sparkles, HeartHandshake, ShieldCheck } from "lucide-react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import site from "@/data/site.json";

const ICONS = { Leaf, Sparkles, HeartHandshake, ShieldCheck };

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1551928692-6954104dee5a?q=80&w=1200&auto=format&fit=crop";

export default function About() {
    return (
        <section id="sobre" data-testid="about-section" className="grain relative overflow-hidden bg-forest py-20 lg:py-28">
            <div
                className="pointer-events-none absolute -right-40 top-0 h-[520px] w-[520px] rounded-full bg-coral/15 blur-[140px]"
                aria-hidden="true"
            />
            <div className="container-x relative grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
                <div>
                    <SectionHeading
                        dark
                        eyebrow="Sobre nós"
                        title={
                            <>
                                Um refúgio de cuidado para quem faz <em className="text-coral">parte da família</em>
                            </>
                        }
                    />
                    <Reveal delay={0.2}>
                        <p className="mt-6 max-w-xl text-sm leading-relaxed text-cream/75 sm:text-base">
                            O Mimo &amp; Pata nasceu de uma ideia simples: tratar cada pet com o mesmo carinho que
                            gostaríamos de receber. Aqui, a boutique, a nutrição e o cuidado estético caminham juntos
                            — com produtos selecionados, atendimento sem pressa e muito afeto em cada detalhe.
                        </p>
                    </Reveal>
                    <Reveal delay={0.28}>
                        <p className="mt-4 max-w-xl text-sm leading-relaxed text-cream/60">
                            Esta apresentação institucional é uma demonstração de portfólio: em um projeto real, aqui
                            estariam a história da equipe, as certificações e o selo da marca.
                        </p>
                    </Reveal>

                    <div className="mt-10 grid gap-4 sm:grid-cols-2">
                        {site.differentials.map((d, i) => {
                            const Icon = ICONS[d.icon] || Sparkles;
                            return (
                                <Reveal key={d.title} delay={0.1 * i} className="h-full">
                                    <div
                                        data-testid={`differential-card-${i + 1}`}
                                        className="h-full rounded-[1.5rem] border border-cream/10 bg-forest-light/40 p-5 backdrop-blur transition-colors duration-500 hover:border-coral/40"
                                    >
                                        <span className="grid h-10 w-10 place-items-center rounded-2xl bg-coral/20 text-coral">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                        <h3 className="mt-3.5 font-serif text-base font-bold text-cream">{d.title}</h3>
                                        <p className="mt-1.5 text-xs leading-relaxed text-cream/60">{d.desc}</p>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>

                <Reveal delay={0.15} className="relative mx-auto w-full max-w-[480px]">
                    <div
                        className="absolute -left-4 -top-4 h-full w-full rounded-[2.5rem] border-2 border-coral/40"
                        aria-hidden="true"
                    />
                    <div className="relative overflow-hidden rounded-[2.5rem] border border-cream/10 shadow-[0_40px_80px_rgba(0,0,0,0.35)]">
                        <img
                            src={ABOUT_IMG}
                            alt="Cão descansando tranquilo em sua cama"
                            loading="lazy"
                            className="aspect-[4/5] w-full object-cover"
                        />
                        <div
                            className="absolute inset-0 bg-gradient-to-t from-forest/50 via-transparent to-transparent"
                            aria-hidden="true"
                        />
                    </div>
                    <div className="absolute -bottom-6 right-4 animate-float rounded-3xl border border-cream/15 bg-forest-light/80 px-5 py-4 shadow-xl backdrop-blur sm:right-8">
                        <p className="font-serif text-lg font-bold text-cream">Do focinho</p>
                        <p className="font-serif text-lg font-bold text-coral">à ponta do rabo.</p>
                        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/50">
                            Cuidado completo · demo
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
